import { Link } from "react-router-dom";
import { Phone, Mail, Linkedin, MapPin } from "lucide-react";
import { BRAND, SERVICES } from "@/lib/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-24 bg-brand-forest text-brand-cream">
      <div className="container-x py-16 grid gap-10 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5">
            <span className="grid h-10 w-10 place-items-center rounded-xl bg-brand-gold text-brand-forest font-outfit font-extrabold text-lg">
              S
            </span>
            <span className="font-outfit font-bold text-lg">{BRAND.name}</span>
          </div>
          <p className="mt-4 text-brand-cream/70 max-w-md text-sm leading-relaxed">
            {BRAND.memoryHook}. Loan facilitation for {BRAND.city} businesses, salaried
            professionals and property investors — backed by 15+ banking and NBFC partners.
          </p>
          <div className="mt-6 space-y-3 text-sm">
            <a data-testid="footer-phone" href={`tel:${BRAND.phoneE164}`} className="flex items-center gap-3 text-brand-cream/85 hover:text-brand-gold transition-colors">
              <Phone className="h-4 w-4 text-brand-gold" /> {BRAND.phone}
            </a>
            <a data-testid="footer-email" href={`mailto:${BRAND.email}`} className="flex items-center gap-3 text-brand-cream/85 hover:text-brand-gold transition-colors">
              <Mail className="h-4 w-4 text-brand-gold" /> {BRAND.email}
            </a>
            <a data-testid="footer-linkedin" href={BRAND.linkedin} target="_blank" rel="noreferrer" className="flex items-center gap-3 text-brand-cream/85 hover:text-brand-gold transition-colors">
              <Linkedin className="h-4 w-4 text-brand-gold" /> LinkedIn — Rajasekhar Kasunur
            </a>
            <div className="flex items-center gap-3 text-brand-cream/85">
              <MapPin className="h-4 w-4 text-brand-gold" /> Bangalore, Karnataka
            </div>
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-outfit font-semibold text-brand-gold text-sm uppercase tracking-[0.18em]">
            Services
          </h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <Link to={`/services#${s.id}`} className="text-brand-cream/75 hover:text-brand-gold transition-colors">
                  {s.title}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/invoice-financing-bangalore" className="text-brand-cream/75 hover:text-brand-gold transition-colors">
                Invoice Financing — IT Vendors
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-outfit font-semibold text-brand-gold text-sm uppercase tracking-[0.18em]">Explore</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/about" className="text-brand-cream/75 hover:text-brand-gold">About</Link></li>
            <li><Link to="/process" className="text-brand-cream/75 hover:text-brand-gold">Process</Link></li>
            <li><Link to="/news" className="text-brand-cream/75 hover:text-brand-gold">News</Link></li>
            <li><Link to="/apply" className="text-brand-cream/75 hover:text-brand-gold">Apply</Link></li>
            <li><Link to="/contact" className="text-brand-cream/75 hover:text-brand-gold">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-outfit font-semibold text-brand-gold text-sm uppercase tracking-[0.18em]">Talk to Raj</h4>
          <Link
            data-testid="footer-apply-btn"
            to="/apply"
            className="mt-4 inline-flex items-center justify-center rounded-full bg-brand-terracotta px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#b25535] transition-all hover:-translate-y-0.5"
          >
            Apply Now
          </Link>
          <a
            data-testid="footer-whatsapp"
            href={`https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent("Hi Raj, I'd like to discuss a loan.")}`}
            target="_blank"
            rel="noreferrer"
            className="mt-2.5 inline-flex w-full items-center justify-center rounded-full border border-brand-gold/40 px-5 py-2.5 text-sm font-semibold text-brand-gold hover:bg-brand-gold hover:text-brand-forest transition-all"
          >
            WhatsApp
          </a>
        </div>
      </div>

      <div className="border-t border-brand-cream/10">
        <div className="container-x py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-brand-cream/55">
          <div>© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</div>
          <div className="flex items-center gap-4">
            <Link to="/admin" data-testid="footer-admin-link" className="hover:text-brand-gold">Admin</Link>
            <span>*48hr approvals on eligible business loans, subject to lender criteria.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
